export default __webpack_public_path__ + "static/media/hero_third.b2ce8801.jpg";